
$.extend($, {
	//RISK MARK AS REVIEW
	riskMarkAndLogDialog: function (riskId, caption, cancelButton, okButton) {
		getMarkButtons = function () {
			var lbuttons = {};
			lbuttons[cancelButton] = function () { closeReviewedLog(); };
			lbuttons[okButton] = function () { saveReviewedLog(); };
			return lbuttons;
		};

		saveReviewedLog = function () {
			$(document).trigger('saveRiskReviewedLog');
		};
		closeReviewedLog = function () {
			$(document).unbind("saveRiskReviewedLog");
			$(document).unbind("closeReviewedLog");
			$.genericPortalCloseDialog(riskMarkDiv, riskMarkDiv, false);
		};

		var riskMarkDiv = $("<div style='background-color:#F0C6A4'></div>");
		var pathname = $.currentSitePath + "Risk.aspx/RiskReport/GetRiskReviewAndLogForm?riskEntity=" + riskId;

		//call the controller for the data
		$.get(pathname, {}, function (data) {
			riskMarkDiv.html(data);
		});

		//open the dialog
		riskMarkDiv.dialog({
			autoOpen: false,
			title: caption,
			closeOnEscape: false,
			width: 530,
			minWidth: 530,
			maxWidth: 530,
			buttons: getMarkButtons(),
			resizable: false,
			modal: true,
			maxHeight: 350,
			position: ['centre', 85]
		});
		$(document).bind('closeReviewedLog', closeReviewedLog);
		riskMarkDiv.AddHelpContext('{5D411126-76A7-4955-9A64-A6241EC165F5}', '{17D85F40-56E9-4bd2-A4EA-827F51549741}');
		riskMarkDiv.dialog("open");
	},
	//RISK REVIEW STAFF  
	riskReviewStaffDialog: function (riskId, title) {
		var riskStaffDiv = $("<div style='background-color:#F0C6A4'></div>");
		var pathname = $.currentSitePath + "Risk.aspx/RiskReview/RiskReviewStaff";

		//call the controller for the data
		$.get(pathname, {}, function (data) {
			riskStaffDiv.html(data);
		});

		getStaffButtons = function () {
			var lbuttons = {};
			lbuttons[$.dictionary.getValue("closeButton")] = function () { closeStaff(); };
			lbuttons[$.dictionary.getValue("saveButton")] = function () { saveRiskReviewStaffChanges(false); };
			return lbuttons;
		}

		closeStaff = function () {
			$(riskStaffDiv).dialog("close");

			riskStaffDiv.remove();
		}

		//open the dialog
		riskStaffDiv.dialog({
			autoOpen: false,
			title: (title || "Staff for Risk Review") + " " + riskId,
			closeOnEscape: false,
			width: 530,
			minWidth: 530,
			maxWidth: 530,
			buttons: getStaffButtons(),
			resizable: false,
			modal: true,
			maxHeight: 350,
			position: ['centre', 85]
		});
		riskStaffDiv.AddHelpContext('{8D65C994-BA2E-42cf-88A3-DC445DAF1AE4}', '{F68B2887-0BA5-452c-9DD9-EB94D4174A1F}');
		riskStaffDiv.dialog("open");
	},
	//RISK LOG DIALOG
	riskLogEntryDialog: function (riskId, cancelBtn, selectBtn, caption) {
		var riskLogDiv = $("<div style='background-color:#F0C6A4'></div>");
		var pathname = $.currentSitePath + "Risk.aspx/RiskReport/GetRiskLog?riskEntity=" + riskId;
		var setpathname = $.currentSitePath + "Risk.aspx/RiskReport/RiskLogSave";

		//call the controller for the data
		$.get(pathname, {}, function (data) {
			riskLogDiv.html(data);
		});

		getLogButtons = function () {
			var lbuttons = {};
			lbuttons[cancelBtn] = function () { closeLog(); };
			lbuttons[selectBtn] = function () { $(document).trigger("RiskLogSave"); };
			return lbuttons;
		}

		closeLog = function () {
			$(document).unbind("RiskLogSave");
			$(riskLogDiv).dialog("close");

			riskLogDiv.remove();
		}

		//open the dialog
		riskLogDiv.dialog({
			autoOpen: false,
			title: caption,
			closeOnEscape: false,
			width: 530,
			minWidth: 530,
			maxWidth: 530,
			buttons: getLogButtons(),
			resizable: false,
			modal: true,
			maxHeight: 350,
			position: ['centre', 85]
		});
		riskLogDiv.AddHelpContext('{2D1A9F88-AFB1-4c14-B2F9-82E152A6F227}', '{17D85F40-56E9-4bd2-A4EA-827F51549741}');
		riskLogDiv.dialog("open");
	},
	//RISK EXISTING DEFENCES/CONTROLS DIALOG
	riskExistingDefenceDialog: function (riskId, defenceId, closeBtn, saveBtn, caption) {
		var existingDefenceDiv = $("<div style='background-color:#F0C6A4'></div>");
		var pathname = $.currentSitePath + "Risk.aspx/RiskReport/GetExistingDefence?riskId=" + riskId + "&defenceId=" + defenceId;

		var setpathname = $.currentSitePath + "Risk.aspx/RiskReport/SaveExistingDefence";

		//call the controller for the data
		$.get(pathname, {}, function (data) {
			existingDefenceDiv.html(data);
		});

		getExistingDefenceButtons = function () {
			var lbuttons = {};
			lbuttons[closeBtn] = function () { closeExistingDefence(); };
			lbuttons[saveBtn] = function () { $(document).trigger("ExistingDefenceSave"); };
			return lbuttons;
		}

		closeExistingDefence = function () {
			$(document).unbind("ExistingDefenceSave");
			$(existingDefenceDiv).dialog("close");

			existingDefenceDiv.remove();
		}

		//open the dialog
		existingDefenceDiv.dialog({
			autoOpen: false,
			title: caption,
			closeOnEscape: false,
			width: 530,
			minWidth: 530,
			maxWidth: 530,
			buttons: getExistingDefenceButtons(),
			resizable: false,
			modal: true,
			maxHeight: 350,
			position: ['centre', 85]
		});
		existingDefenceDiv.AddHelpContext('{C7DB6410-3AE8-4BD2-B81A-1FDD01EF1974}', '{17D85F40-56E9-4bd2-A4EA-827F51549741}');
		existingDefenceDiv.dialog("open");
	},
	//RISK LEVEL DIALOG
	riskLevelDialog: function (riskLevel, options) {
		$('#riskLevelDiv').remove();
		var riskLevelDiv = $("<div id='riskLevelDiv' ></div>").appendTo($(document.body));
		var pathname = $.currentSitePath + "Risk.aspx/RiskMatrix/RiskLevelTool";
		var buttonPath = $.currentSitePath + "Risk.aspx/RiskMatrix/RiskLevelToolButtons?riskLevel=" + riskLevel;
		var title = "Select " + riskLevel + " Risk Level";
		var selectBtn;
		var closeBtn;
		//set currentvalue
		if (options.caption != undefined) {
			title = options.caption;
		}
		if (riskLevel.toLowerCase() == "initial")
			pathname = pathname + "?isInitial=true";
		else
			pathname = pathname + "?isInitial=false";
		if (options) {
			if (options.showConsequenceData == true) {
				pathname = pathname + "&showConsequenceData=true";
			}
			if (options.showConsequenceMatrix != undefined) {
				if (options.showConsequenceMatrix == true) {
					pathname = pathname + "&showConsequenceMatrix=true";
				} else if (options.showConsequenceMatrix == false) {
					pathname = pathname + "&showConsequenceMatrix=false";
				}
			}
			if (options.likelihood) {
				pathname = pathname + "&likelihood=" + options.likelihood;
			}

			if (options.riskNo) {
				pathname = pathname + "&riskNo=" + options.riskNo;
			}
			if (options.severity) {
				pathname = pathname + "&severity=" + options.severity;
			}

			if (options.updateMode) {
				buttonPath = buttonPath + "&updateMode=true";
				pathname = pathname + "&updateMode=true";
			}
			if (options.multiSelect) {
				buttonPath = $.extendUrl(buttonPath, { multiSelect: true });
				pathname = $.extendUrl(pathname, { multiSelect: true });
			}
			if (options.locationId) {
				pathname = pathname + "&locationId=" + options.locationId;
			}
		}
		//call the controller for the data
		if (options && options.matrixLoaded)
			riskLevelDiv.bind("riskMatrixPanelUpdated", options.matrixLoaded);


		getRiskLevelButtons = function () {
			var lbuttons = {};
			var selected = function () {
				// MZ270113: Only trigger event if matrix data contains a value
				if (!jQuery.isEmptyObject(matrixData)) {

					$(document).trigger({
						type: 'MatrixSelection',
						selected: matrixData,
						consequenceData: consequenceData,
						riskLevel: riskLevel
					});
				}
				closeRiskLevelDialog();
			};
			$(document).bind('levelSelectedDoubleClick', selected);
			lbuttons[closeBtn] = function () { closeRiskLevelDialog(); };
			if (selectBtn.length > 0) {
				lbuttons[selectBtn] = selected;
			}
			return lbuttons;
		}
		//handleMatrixSelection($("#matrixLikelihoodData").val(), $("#matrixSeverityData").val(), riskLevel); 
		closeRiskLevelDialog = function () {
			$(document).unbind("MatrixSelection");
			$.genericPortalCloseDialog(riskLevelDiv, riskLevelDiv, false);
		};

		getButtonsFromControl = function () {
			//gets the button txts
			$.ajax({
				type: "GET",
				url: buttonPath,
				dataType: "json",
				async: false,
				success: function (data) {
					if (data.title.length > 0) { title = data.title; }
					selectBtn = data.select;
					closeBtn = data.close;
				}
			});
		}

		//here is the actual processing
		getButtonsFromControl();

		var leftPos = ($(window).width() / 2) - 500;
		if (leftPos < 0) { leftPos = 0; }
		//open the dialog
		riskLevelDiv.dialog({
			autoOpen: false,
			title: title,
			closeOnEscape: false,

			minWidth: 614,
			maxWidth: 1065,
			buttons: getRiskLevelButtons(),
			resizable: false,
			modal: true,
			position: { my: "center", at: "center", of: window }
		});
		$(document).on('ajaxStop',
			function () {
				riskLevelDiv.parent().position({ my: "center", at: "center", of: window });

			});
		riskLevelDiv.AddHelpContext('{62DC581E-4A37-4d17-8E14-C51CA2684B96}', '{17D85F40-56E9-4bd2-A4EA-827F51549741}');
		riskLevelDiv.dialog("open");
		$.get(pathname, {}, function (data) {
			riskLevelDiv.html(data);

		});

	},

	//HAZARD LOG DIALOG
	hazardLogEntryDialog: function (hazardId) {
		var hazardLogDiv = $("<div style='background-color:#F0C6A4'></div>");
		var pathname = $.currentSitePath + "Risk.aspx/Hazard/GetHazardLog?hazardEntity=" + hazardId;

		//call the controller for the data
		$.get(pathname, {}, function (data) {
			hazardLogDiv.html(data);
		});

		getLogButtons = function () {
			var lbuttons = {};
			lbuttons["Close"] = function () { closeLog(); };
			lbuttons["Save"] = function () { $(document).trigger("hazardLogSave"); };
			return lbuttons;
		}

		closeLog = function () {
			$(document).unbind("hazardLogSave");
			$(hazardLogDiv).dialog("close");

			hazardLogDiv.remove();
		}

		//open the dialog
		hazardLogDiv.dialog({
			autoOpen: false,
			title: "New Log entry",
			closeOnEscape: false,
			width: 530,
			minWidth: 530,
			maxWidth: 530,
			buttons: getLogButtons(),
			resizable: false,
			modal: true,
			maxHeight: 350,
			position: ['centre', 85]
		});
		hazardLogDiv.AddHelpContext('{B9B969E9-F249-49b4-99E5-A72EF3FDE1BE}', '{240D6E53-28E8-42c7-B977-706F7818044C}');
		hazardLogDiv.dialog("open");
	},
	//HAZARD LINK DIALOG
	hazardLinkDialog: function (cancelBtn, selectBtn, caption) {
		var hazardLinkDiv = $("<div style='background-color:#F0C6A4'></div>");
		var pathname = $.currentSitePath + "Risk.aspx/Hazard/LinkToExistingHazard";
		var setpathname = $.currentSitePath + "Risk.aspx/Hazard/HazardLinkSave";

		//call the controller for the data
		$.get(pathname, {}, function (data) {
			hazardLinkDiv.html(data);
		});

		getLinkButtons = function () {
			var lbuttons = {};
			lbuttons[cancelBtn] = function () { closeLink(); };
			lbuttons[selectBtn] = function () { saveLink(); };
			return lbuttons;
		}

		closeLink = function () {
			$(document).unbind("SelectLink");
			$(document).unbind("HazardLinkChange");
			$(hazardLinkDiv).dialog("close");

			hazardLinkDiv.remove();
		}

		saveLink = function () {
			//saves the link
			$(document).trigger("SelectLink");
		}

		//open the dialog
		hazardLinkDiv.dialog({
			autoOpen: false,
			title: caption,
			closeOnEscape: false,
			width: 1035,
			minWidth: 530,
			maxWidth: 1035,
			buttons: getLinkButtons(),
			resizable: false,
			modal: true,
			maxHeight: 490,
			height: 490,
			position: ['centre', 85]
		});
		hazardLinkDiv.AddHelpContext('{3C337710-63BC-441d-BBC6-9C94B8910A54}', '{240D6E53-28E8-42c7-B977-706F7818044C}');
		hazardLinkDiv.dialog("open");
	},
	//HAZARD MARK AS REVIEW
	hazardMarkAndLogDialog: function (hazardId, markReviewedTitle) {
		getHazardMarkButtons = function () {
			var lbuttons = {};
			lbuttons[$.dictionary.getValue("closeButton")] = function () { closeHazardMarkLog(); };
			lbuttons[$.dictionary.getValue("saveButton")] = function () { $(document).trigger("saveHazardMarkLog"); };
			return lbuttons;
		}

		closeHazardMarkLog = function () {
			$(document).unbind("saveHazardMarkLog");
			$(hazardMarkDiv).dialog("close");

			hazardMarkDiv.remove();
		}

		var hazardMarkDiv = $("<div style='background-color:#F0C6A4'></div>");
		var pathname = $.currentSitePath + "Risk.aspx/Hazard/GetHazardLog?hazardEntity=" + hazardId;

		//call the controller for the data
		$.get(pathname, {}, function (data) {
			hazardMarkDiv.html(data);
		});

		//open the dialog
		hazardMarkDiv.dialog({
			autoOpen: false,
			title: markReviewedTitle || "Mark Hazard as Reviewed",
			closeOnEscape: false,
			width: 530,
			minWidth: 530,
			maxWidth: 530,
			buttons: getHazardMarkButtons(),
			resizable: false,
			modal: true,
			maxHeight: 350,
			position: ['centre', 85]
		});
		hazardMarkDiv.AddHelpContext('{BCA036B4-F90B-4d7d-AD6F-0741A631B79C}', '{240D6E53-28E8-42c7-B977-706F7818044C}');
		hazardMarkDiv.dialog("open");
	},
	//OCCURRENCE FOR RISK DIALOG
	riskOccurrenceDialog: function (occurrenceId, isReviewed, isRM_Coord) {
		alert(occurrenceId);
		var riskOccurrenceDiv = $("<div style='background-color:#F0C6A4'></div>");
		var pathname = $.currentSitePath + "Safety.aspx/Occurrence/ViewOccurrence?occurrenceNo=" + occurrenceId;
		var qformurl = $.currentSitePath + "QForm.aspx/QForms/ViewQForm?occurrenceNo=" + occurrenceId;
		var setpathname = $.currentSitePath + "Risk.aspx/Occurrence/MarkOccurrenceAsReviewed?occurrenceNo=" + occurrenceId;
		var buttonPath = $.currentSitePath + "Risk.aspx/Occurrence/GetOccurrenceButtons?occurrenceNo=" + occurrenceId;
		var occButton;
		var reviewedBtn;
		var closeBtn;

		getRiskOccButtons = function () {
			var lbuttons = {};
			lbuttons[closeBtn] = function () { closeRiskOcc(); };
			if (reviewedBtn.length > 0) { lbuttons[reviewedBtn] = function () { saveRiskOcc(); } }
			if (occButton.length > 0) { lbuttons[occButton] = function () { viewOccurrence(); } }
			return lbuttons;
		}

		closeRiskOcc = function () {
			$(riskOccurrenceDiv).dialog("close");

			riskOccurrenceDiv.remove();
		}

		saveRiskOcc = function () {
			//saves the occurrence changes
			$.post(setpathname, "", function (result) { $("#risk_newoccurrences").trigger("reloadGrid"); $("#risk_reviewoccurrences").trigger("reloadGrid"); closeRiskOcc(); });
		}

		viewOccurrence = function () {
			$(document).trigger('js/openoccurrencedialog', { originalUrl: qformurl + "&formId=" + $('#FormID').val(), parameters: { formId: $('#FormID').val(), title: $('#OccurrenceTypes').val() + " Occurrence " + occurrenceId, id: occurrenceId } });
		}

		getButtonsFromControl = function () {
			//here is the actual processing
			//gets the button txts
			$.ajax({
				type: "GET",
				url: buttonPath,
				dataType: "json",
				async: false,
				success: function (data) {
					occButton = data.occurrence;
					reviewedBtn = data.markasreview;
					closeBtn = data.close;
				}
			});
		}

		//do the processing
		getButtonsFromControl();
		//call the controller for the data
		$.get(pathname, {}, function (data) {
			riskOccurrenceDiv.html(data);
		});


		//open the dialog
		riskOccurrenceDiv.dialog({
			autoOpen: false,
			title: "Occurrence Risk Details",
			closeOnEscape: false,
			width: 530,
			minWidth: 530,
			maxWidth: 530,
			buttons: getRiskOccButtons(),
			resizable: false,
			modal: true,
			maxHeight: 350,
			position: ['centre', 85]
		});
		riskOccurrenceDiv.AddHelpContext('{BC5BB3FC-FBCC-45bf-9026-2E9C90FD7BD9}', '{98FB4BA5-C18A-4326-B2DB-33F057E3AF6A}');
		riskOccurrenceDiv.dialog("open");
	},
	//Print
	printDialog: function (riskId, url, closeBtn, printBtn, caption) {
		if (caption == undefined) {
			caption = "Print Risk " + riskId;
		}
		getPrintButtons = function () {
			var lbuttons = {};
			if (closeBtn == undefined) {
				closeBtn = "Close";
			}
			if (printBtn == undefined) {
				printBtn = "Print";
			}
			lbuttons[closeBtn] = function () { closePrint(); };
			lbuttons[printBtn] = function () { Print_onclick(); };
			return lbuttons;
		};

		closePrint = function () {
			$(printDiv).dialog("close");

			printDiv.remove();
		};

		var printDiv = $("<div style='background-color:#F0C6A4'></div>");
		var pathname = $.currentSitePath + "Risk.aspx/RiskReport/PrintRiskDialog?risk=" + riskId;

		//call the controller for the data
		$.get(pathname, {}, function (data) {
			printDiv.html(data);
		});

		//open the dialog
		printDiv.dialog({
			autoOpen: false,
			title: caption,
			closeOnEscape: false,
			width: 530,
			minWidth: 530,
			maxWidth: 530,
			buttons: getPrintButtons(),
			resizable: false,
			modal: true,
			maxHeight: 350,
			position: ['centre', 85]
		});
		printDiv.AddHelpContext('{B7BF876B-B64A-467f-AFC0-97F250775E94}', '{17D85F40-56E9-4bd2-A4EA-827F51549741}');
		printDiv.dialog("open");
	},

	//RISK LINK DIALOG
	riskLinkDialog: function (linkSource, title) {
		var riskLinkDiv = $("<div class='areaBg'></div>");
		var pathname = $.currentSitePath;
		if (linkSource == undefined) {
			pathname = pathname + "Risk.aspx/RiskReview/LinkToExistingRisk";
		}
		else {
			pathname = pathname + "Risk.aspx/" + linkSource + "/LinkToExistingRisk";
		}
		var setpathname = $.currentSitePath + "Risk.aspx/RiskReview/RiskLinkSave";

		//call the controller for the data
		$.get(pathname, {}, function (data) {
			riskLinkDiv.html(data);
		});

		getLinkButtons = function () {
			var lbuttons = {};
			lbuttons[$.dictionary.getValue("cancelButton")] = function () { closeRiskLink(); };
			lbuttons[$.dictionary.getValue("selectButton")] = function () { saveRiskLink(); };
			return lbuttons;
		}

		closeRiskLink = function () {
			$(document).unbind("SelectRiskLink");
			$(document).unbind("RiskLinkChange");
			$(riskLinkDiv).dialog("close");

			riskLinkDiv.remove();
		}

		saveRiskLink = function () {
			//saves the link
			$(document).trigger("SelectRiskLink");
		}

		//open the dialog
		riskLinkDiv.dialog({
			autoOpen: false,
			title: title || "Link Existing Risk",
			closeOnEscape: false,
			width: 780,
			minWidth: 530,
			maxWidth: 780,
			buttons: getLinkButtons(),
			resizable: false,
			modal: true,
			maxHeight: 600,
			position: ['centre', 85]
		});
		riskLinkDiv.AddHelpContext('{07FD8DE3-23D6-41ac-BCAF-8B152B28F861}', '{240D6E53-28E8-42c7-B977-706F7818044C}');
		riskLinkDiv.dialog("open");
	},
	//HAZARD LINK TO RISK REVIEW DIALOG
	hazardLinkToReviewDialog: function (title) {
		var hazardLinkDiv = $("<div style='background-color:#F0C6A4'></div>");
		var pathname = $.currentSitePath + "Risk.aspx/RiskReview/LinkToExistingHazard";

		//call the controller for the data
		$.get(pathname, {}, function (data) {
			hazardLinkDiv.html(data);
		});

		getLinkButtons = function () {
			var lbuttons = {};
			lbuttons[$.dictionary.getValue("cancelButton")] = function () { closeLink(); };
			lbuttons[$.dictionary.getValue("selectButton")] = function () { saveLink(); };
			return lbuttons;
		}

		closeLink = function () {
			$(document).unbind("SelectLink");
			$(document).unbind("HazardLinkChange");
			$(hazardLinkDiv).dialog("close");

			hazardLinkDiv.remove();
		}

		saveLink = function () {
			//saves the link
			$(document).trigger("SelectLink");
		}

		//open the dialog
		hazardLinkDiv.dialog({
			autoOpen: false,
			title: title || "Link Existing Hazard",
			closeOnEscape: false,
			width: 780,
			minWidth: 530,
			maxWidth: 780,
			buttons: getLinkButtons(),
			resizable: false,
			modal: true,
			maxHeight: 500,
			position: ['centre', 85]
		});
		hazardLinkDiv.AddHelpContext('{3C337710-63BC-441d-BBC6-9C94B8910A54}', '{F68B2887-0BA5-452c-9DD9-EB94D4174A1F}');
		hazardLinkDiv.dialog("open");
	},
	//RISK REVIEW LINK TO RISK DIALOG
	riskReviewLinkDialog: function (cancelBtn, selectBtn, caption) {
		var rrLinkDiv = $("<div style='background-color:#F0C6A4'></div>");
		var pathname = $.currentSitePath + "Risk.aspx/RiskReport/LinkToExistingReview";
		var setpathname = $.currentSitePath + "Risk.aspx/RiskReport/RiskReviewLinkSave";

		//call the controller for the data
		$.get(pathname, {}, function (data) {
			rrLinkDiv.html(data);
		});

		getLinkButtons = function () {
			var lbuttons = {};
			lbuttons[cancelBtn] = function () { closeLink(); };
			lbuttons[selectBtn] = function () { saveLink(); };
			return lbuttons;
		}

		closeLink = function () {
			$(document).unbind("SelectRiskReviewLink");
			$(document).unbind("RiskReviewLinkChange");
			$(rrLinkDiv).dialog("close");

			rrLinkDiv.remove();
		}

		saveLink = function () {
			//saves the link
			$(document).trigger("SelectRiskReviewLink");
		}

		//open the dialog
		rrLinkDiv.dialog({
			autoOpen: false,
			title: caption,
			closeOnEscape: false,
			width: 920,
			minWidth: 530,
			maxWidth: 780,
			buttons: getLinkButtons(),
			resizable: false,
			modal: true,
			maxHeight: 400,
			position: ['centre', 85]
		});
		rrLinkDiv.AddHelpContext('{589547C2-64EB-46F3-91EF-A5898D77BA9C}', '{240D6E53-28E8-42c7-B977-706F7818044C}');
		rrLinkDiv.dialog("open");
	}

})
